if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('.disclosure__button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.overlay = this.querySelector('.localization-drawer-overlay');
      this.closeBtn = this.querySelector('.localization-drawer-close');
      this.isHeaderContext = this.closest('.header__localization') !== null;
      this.mobileQuery = window.matchMedia('(max-width: 749px)');

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

      if (this.overlay) {
        this.overlay.addEventListener('click', this.closeDrawer.bind(this));
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.closeDrawer.bind(this));
      }
    }

    get isMobileDrawer() {
      return this.isHeaderContext && this.mobileQuery.matches;
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      if (this.isMobileDrawer) {
        this.closeDrawer();
      } else {
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      if (this.isMobileDrawer) {
        this.openDrawer();
      } else {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }
    }

    openDrawer() {
      this.elements.panel.removeAttribute('hidden');
      // Force reflow so the transition animates from translateY(100%)
      this.elements.panel.offsetHeight;
      this.elements.panel.classList.add('localization-drawer--open');
      if (this.overlay) this.overlay.classList.add('localization-drawer-overlay--visible');
      this.elements.button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('localization-body-lock');
    }

    closeDrawer() {
      this.elements.panel.classList.remove('localization-drawer--open');
      if (this.overlay) this.overlay.classList.remove('localization-drawer-overlay--visible');
      this.elements.button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('localization-body-lock');
      // Wait for slide-down animation before hiding
      setTimeout(() => {
        if (!this.elements.panel.classList.contains('localization-drawer--open')) {
          this.elements.panel.setAttribute('hidden', true);
        }
      }, 220);
    }

    closeSelector(event) {
      // Mobile drawer handles its own close via overlay/X button
      if (this.isMobileDrawer) return;
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
